/**
 * Resource Preloading Utility
 * Preloads critical resources for better performance
 */

// Preload critical fonts
export const preloadFonts = () => {
  const fonts = [
    // Add your custom font URLs here if any
  ];

  fonts.forEach((fontUrl) => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'font';
    link.type = 'font/woff2';
    link.href = fontUrl;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  });
};

// Preload critical images
export const preloadImages = (imageUrls) => {
  imageUrls.forEach((url) => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = url;
    document.head.appendChild(link);
  });
};

// Prefetch routes that user is likely to visit
export const prefetchRoute = (routePath) => {
  const link = document.createElement('link');
  link.rel = 'prefetch';
  link.href = routePath;
  document.head.appendChild(link);
};

// DNS prefetch for external domains
export const dnsPrefetch = (domains) => {
  domains.forEach((domain) => {
    const link = document.createElement('link');
    link.rel = 'dns-prefetch';
    link.href = domain;
    document.head.appendChild(link);
  });
};

// Preconnect to external domains
export const preconnect = (domains) => {
  domains.forEach((domain) => {
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = domain;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  });
};

// Initialize all preloading optimizations
export const initResourcePreloading = () => {
  // Preconnect to critical external services
  preconnect([
    process.env.REACT_APP_BACKEND_URL || '',
    'https://www.google-analytics.com',
  ].filter(Boolean));

  // DNS prefetch for CDNs
  dnsPrefetch([
    'https://fonts.googleapis.com',
    'https://fonts.gstatic.com',
  ]);
};

export default {
  preloadFonts,
  preloadImages,
  prefetchRoute,
  dnsPrefetch,
  preconnect,
  initResourcePreloading
};
